import React from 'react';

import { RangePicker } from 'react-trip-date';

import { Dialog, DialogContent, /*DialogActions, Button,*/ WithStyles, DialogTitle, Typography, MuiThemeProvider, createTheme, Button, DialogActions, Grid } from '@material-ui/core';
import { Theme, withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
//import { AppBar, Toolbar, Typography } from '@material-ui/core';

//import { Trans } from 'react-i18next';

import { connect } from 'react-redux';

import { Actions, AppState, IPageState, store } from '../../appredux';

import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import moment from "moment";

import MomentUtils from "@date-io/moment";

import { setLocale } from '../common/localeHelpers';
import { daysFromDate, datediff, capitalize } from '../common/helpers';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosSharpIcon from '@mui/icons-material/ArrowBackIosSharp';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';
import './calendar.css'
import FlagIconsCalendar from './FlagIconsCalendar';

const theme = {
	primary: {
		light: "rgb(250,135,4)",
		main: "rgb(250,135,4)",
		dark: "rgb(250,135,4)",
		//dark: "#e65100",
	},
	grey: {
		700: "#707070",
		900: "#1b1b1d",
	},
	background: {
		default: "#f5f5f5",

	},
	text: {
		disabled: "#BABABA",
	},
}

const themeEdit = createTheme({
	palette: {
		primary: { main: "#458B00" },
		secondary: { light: green[50], main: "rgb(230, 81, 0)", dark: '#69b076' },
		error: { main: "rgb(244, 67, 54)" },
		text: { secondary: "#555" }
	},
	overrides: {
		MuiPaper: {
			root: {
				fontSize: "14px",
				fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
				//lineHeight: "14px",
				//fontWeight: "bold" as "bold",
				//textTransform: "lowercase" as "lowercase",
				//padding: "14px",
			}
		},
		MuiButton: {
			root: {
				padding: "6px 20px"
			}
		}
	}
});

interface DialogProps extends WithStyles<typeof styles> {
	page: IPageState,
	opened: boolean,
	close: () => void,
	accept: (date: any) => void,
	dateFrom: string,
	dateTo: string,
	windowWidth: number
}

type DialogState = {
	from: string,
	to: string,
	initial: string,
}

class MyApp extends React.Component<DialogProps & WithTranslation & TransProps, DialogState> {

	constructor(props: DialogProps & WithTranslation & TransProps) {
		super(props, {}); 
		this.state = {
			from: this.props.dateFrom,
			to: this.props.dateTo,
			initial: daysFromDate(new Date(), 0).slice(0, 7)
		}
	}

	onChange = (date: any) => {
		this.setState({ from: date.from, to: date.to })
	}

	accept = () => {
		this.props.accept({ from: this.state.from, to: this.state.to })
	}

	setToday = () => {
		let initial = daysFromDate(new Date(), 0).slice(0, 7) + "-" + Math.floor(Math.random() *25)
		this.setState({ from: daysFromDate(new Date(), 0), to: daysFromDate(new Date(), 1), initial: initial }) 
	}
	setTomorrow = () => {
		let initial = daysFromDate(new Date(), 0).slice(0, 7) + "-" + Math.floor(Math.random() *25)
		this.setState({ from: daysFromDate(new Date(), 1), to: daysFromDate(new Date(), 2), initial: initial }) 
	}
	setWeekend = () => { //piątek - miedziela
		let initial = daysFromDate(new Date(), 0).slice(0, 7) + "-" + Math.floor(Math.random() *25)

		let todayNum = moment(new Date()).locale(this.props.page.lang).day()
		let pt: string
		let nd: string

		if(todayNum <= 5){ //piątek lub wcześniej
			pt = moment(new Date()).locale(this.props.page.lang).endOf("week").subtract(2, 'days').format('YYYY-MM-DD')
			nd = moment(new Date()).locale(this.props.page.lang).endOf("week").format('YYYY-MM-DD')
		} else { //sob, nd    ustawiam kolejny tydzień
			pt = moment(new Date()).locale(this.props.page.lang).add(3, 'days').endOf("week").subtract(2, 'days').format('YYYY-MM-DD')
			nd = moment(new Date()).locale(this.props.page.lang).add(3, 'days').endOf("week").format('YYYY-MM-DD')
		}

		this.setState({ from: pt, to: nd, initial: initial }) 
	}

	componentDidUpdate(prevProps: DialogProps) {
		if (this.props.dateFrom !== prevProps.dateFrom || this.props.dateTo !== prevProps.dateTo ||
			this.props.opened != prevProps.opened) {
			this.setState({ from: this.props.dateFrom, to: this.props.dateTo })
		}
	}

	componentDidMount() {
		// let header = document.getElementById("rangePicker") as HTMLElement
		// header.innerText
		// header.innerHTML = header.innerHTML.replace('April','Kwiecień')
		// let todayTable = document.getElementsByClassName("today") as HTMLCollection
		// let today = todayTable.item(0) as HTMLElement
		//  console.log(today )
		// console.log(header )
		// console.log(header.innerText )
		// console.log(header.innerHTML)

		// let header1 = document.getElementsByClassName("sc-gsDJrp krLVYq") as HTMLCollection
		// let qwe = header1.item(0) as HTMLElement
		// //qwe.innerText = qwe.innerHTML.replace('April','Kwiecień')
		// //qwe.outerHTML = qwe.outerHTML.replace('April','Kwiecień')
		// //qwe.outerText = qwe.innerText.replace('April','Kwiecień')
		// //qwe.innerHTML = qwe.innerHTML.replace('April','Kwiecień')
		// header1.length
		// console.log(header1 )
		// console.log(header1.length )
		// //console.log(header.namedItem(0))
		// console.log(header1.item(0))
		// console.log(qwe)
		// console.log(qwe.innerHTML)
		// console.log(qwe.innerHTML.replace('April','Kwiecień'))
		// console.log(qwe.children)
		// //qwe.children[1].innerHTML= "qwe"
		// //qwe.children[1].outerHTML= "qwe"
		// let a = qwe.getElementsByTagName("p")
		// console.log(a)
		// let b = a.item(0) as HTMLElement
		// console.log(b)
		// //b.innerHTML = "qwe"
		// //b.outerHTML = "qwe"
		// //b.innerText = b.innerText + "lol"
		// //b.innerHTML = b.innerText + "lol"
		// console.log(b)



		// console.log(document.getElementsByTagName("p"))


		// let n = document.getElementsByTagName("p")
		// console.log(n)
		// let m = n.item(0) as HTMLElement
		// m.outerHTML = m.outerHTML.replace('April','Kwiecień')
		// console.log(m)



	}

	minusDayFrom = async () => {
		if(this.state.from && this.state.to){
			let date = daysFromDate(new Date(this.state.from), -1)
			let date1 = daysFromDate(new Date(this.state.from), 0)

			if (new Date().getTime() < new Date(date1).getTime()){
				this.setState({ ...this.setState, from: date });
			}
		}
    };
	plusDayFrom = async () => {
		if (this.state.from && this.state.to) {
			let dateFrom = daysFromDate(new Date(this.state.from), 1)
			let dateTo = daysFromDate(new Date(this.state.to), 0)
			let dateTo1 = daysFromDate(new Date(this.state.to), 1)

			this.setState({ ...this.setState, from: dateFrom });

			if (new Date(dateFrom).getTime() >= new Date(dateTo).getTime()) {
				this.setState({ ...this.setState, to: dateTo1 });
			}
		}
	}
	minusDayTo = async () => {
		if (this.state.from && this.state.to) {
			let dateFrom = daysFromDate(new Date(this.state.from), 0)
			let dateFrom1 = daysFromDate(new Date(this.state.from), -1)
			let dateTo1 = daysFromDate(new Date(this.state.to), -1)

			if(new Date().getTime() < new Date(dateTo1).getTime()){

			this.setState({ ...this.setState, to: dateTo1 });

			if (new Date(dateFrom).getTime() >= new Date(dateTo1).getTime()) {
				this.setState({ ...this.setState, from: dateFrom1 });
			}
		}
		}
    };
	plusDayTo = async () => {
		if(this.state.from && this.state.to){
			let date = daysFromDate(new Date(this.state.to), 1)
            this.setState({ ...this.setState, to: date });
		}
    };

	dayRender = (day: any) => {
		let value = Number(day.day.split('-')[2])
		return (
			<div>{value}</div>
		)
	}

	setMaxi = () => {
		store.dispatch(Actions.pageState.setGrafikMaxiMini(0))
	}

	getDayOfWeek = (param: string) => {
        return moment(param).locale(this.props.page.lang).format('dddd').split(' ')//[1].toLowerCase();
    }

	setLang = (num: number) => {
		let nextLang = "pl"
		let langs = ["pl", "en", "de", "sk"]
		let index = langs.findIndex(x => this.props.page.lang === x)

		if(index !== -1){
			if(langs[index + num]){
				nextLang = langs[index + num]
			} else if(num >= 0){
				nextLang = langs[0]
			} else if(num < 0){
				nextLang = langs[langs.length -1]
			}
		}

		store.dispatch(Actions.pageState.setLang(nextLang));
	}

	//PM 2021-05-13
	render() {
		const { classes, t } = this.props;

		
		moment.locale(this.props.page.lang)
		let weekDays = moment.weekdaysShort()
		//if(this.props.page.lang === "en"){
		//	weekDays = weekDays //.map(x => x.toLowerCase())
		//}else
		if(this.props.page.lang === "de"){
			weekDays = weekDays.map(x => x.split(".").join(""))
		}
		weekDays = weekDays.map(x => capitalize(x))

		// if (this.props.opened) {

		// 	let time = setInterval(() => {
		// 		let todayTable = document.getElementsByClassName("today") as HTMLCollection
		// 		let today = todayTable.item(0) as HTMLElement
		// 		if (today) {
		// 			today.style.border = "0";
		// 			//today.style.borderRadius = "0";
		// 			clearInterval(time)
		// 		}
		// 	}, 100);

		// 	//   let time1 = setInterval(() => {
		// 	// 	let inactiveTable = document.getElementsByClassName("inactive") as HTMLCollection
		// 	// 	let t = []
		// 	// 	for (let i = 0; i < inactiveTable.length; i++) {
		// 	// 		t.push(inactiveTable.item(i))
		// 	// 	}
		// 	// 	for (let y = 0; y < t.length; y++) {
		// 	// 		(t[y]as HTMLElement ).style.height  = "0";

		// 	// 	}
		// 	// 	if( inactiveTable.length > 0){
		// 	// 		clearInterval(time1)
		// 	// 	}
		// 	// }, 100);

		// }


		let diff = String(datediff(new Date(this.state.from), new Date(this.state.to)))
		let diffText = (Number(diff) > 1 || Number(diff) === 0  ?  t("Days") :  t("Day"))

		if(diff === "NaN"){
			diff = ""
			diffText = ""

		}

		const rangePickerProps = {
			
			onChange: this.onChange,
			theme: theme,
			//startOfWeek={6}
			//handleChange={this.onChange}
			selectedDays: { from: this.state.from, to: this.state.to }, //initial selected days
			jalali: false,
			//numberOfMonths: this.props.windowWidth > 700 ? 2 : 1,
			numberOfMonths: 2,
			autoResponsive: true,
			initialMonthAndYear: this.state.initial,
			//numberOfSelectableDays: 5, // number of days you need
			//disabledDays={['2019-12-02']} //disabeld days
			//responsive={handleResponsive} // custom responsive, when using it, `numberOfMonths` props not working
			
			disabledBeforeDate: daysFromDate(new Date(), 0),
			disabled: false, // disable calendar
			//dayComponent={Day} //custom day component
			startOfWeek: 1,
			components: {
				days: this.dayRender,

				//titleOfWeek: { titles: ["nd", "pon", "wt", "śr", "czw", "pt", "sob", ] },
				titleOfWeek: { titles: weekDays },
				header: { format: 'MMMM MM YYYY',  }
			},
			//titleComponent={Title} // custom title of days
		};

		return (
			<MuiThemeProvider theme={themeEdit}>
				<Dialog

					onClose={() => this.props.close()}
					open={this.props.opened}
					fullWidth
					PaperProps={{ style: { margin: "16px", width: "100%" } }}
					classes={{ paper: classes.paper }}

				>
					<DialogTitle disableTypography style={{ position: "sticky", left: "0px", padding: this.props.windowWidth < 500 ? "20px 4px 0px 4px" : "20px 12px 0px 12px" }}>


						{/* <Typography variant="h6" component="h2" color="primary" style={{ textAlign: "center", fontSize: this.props.windowWidth < 600 ? "0.9rem" : "1.14rem", textTransform: "lowercase" }}>
							{this.props.windowWidth > 600 ?
								<><Trans>Check-in</Trans> {" "} <span className={classes.secondary}>{this.state.from}</span>   {" "}<Trans>Check-out</Trans>{" "}  <span className={classes.secondary}>{this.state.to}</span> {" " + diffText + " "} <span className={classes.secondary}>{diff}</span></>
								:
								<><p style={{ margin: "auto", textTransform: "lowercase" }}><Trans>Check-in</Trans> {" "} <span className={classes.secondary}>{this.state.from}</span>   {" "}<Trans>Check-out</Trans>{" "}  <span className={classes.secondary}>{this.state.to}</span></p>
									<p style={{ margin: "auto", paddingTop: "12px" }}> {" " + diffText + " "} <span className={classes.secondary}>{diff}</span></p></>


							}
						</Typography> */}

						{/* <Grid container direction="row" alignItems='center' justifyContent='center'>
							<Grid item xs={6}>
								<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "end", fontSize: "14px", textTransform: "lowercase" }}>
									<Trans>Check-in</Trans>{" "} <span className={classes.secondary}>{this.state.from}</span>
									<Button variant="outlined" color="primary"
										className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}

										style={{ marginLeft: "3px", marginRight: "1px" }}
										onClick={() => this.minusDayFrom()}
									>
										<ChevronLeftIcon style={{ paddingBottom: "1px" }} />
									</Button>

								</Typography>



							</Grid>
							<Grid item xs={6}>
							<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "left", fontSize: "14px" }}>


								<Button variant="outlined" color="primary"
									className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}

									style={{ marginLeft: "3px", marginRight: "1px" }}
									onClick={() => this.plusDayFrom()}
								>
									<ChevronRightIcon style={{ paddingBottom: "1px" }} />
								</Button>

									<span className={classes.secondary}>{" " + this.getDayOfWeek(this.state.from)}</span>

								</Typography>

							</Grid>
							<Grid item xs={6}>
								<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "end", fontSize: "14px", whiteSpace: "break-spaces", textTransform: "lowercase" }}>
									<Trans>Check-out</Trans>{" "}<span className={classes.secondary}>{this.state.to}</span>
									<Button variant="outlined" color="primary"
										className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}

										style={{ marginLeft: "3px", marginRight: "1px" }}
										onClick={() => this.minusDayTo()}
										>
										<ChevronLeftIcon style={{ paddingBottom: "1px" }} />
									</Button>
								</Typography>
							</Grid>
							<Grid item xs={6} style={{textAlign: "center"}}>

								<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "left", fontSize: "14px", whiteSpace: "break-spaces" }}>

									<Button variant="outlined" color="primary"
										className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
										//className={`${classes.dateButton} ${classes.size}`}
										style={{ marginLeft: "3px", marginRight: "1px" }}
										onClick={() => this.plusDayTo()}
										>
										<ChevronRightIcon style={{ paddingBottom: "1px" }} />
									</Button>
									{this.state.to ? <>
										<span className={classes.secondary}>{" " + this.getDayOfWeek(this.state.to) + ", "}
											{diff} {diffText}</span>
									</> : null}
								</Typography>
							</Grid>
						</Grid> */}






						<Grid container direction="row" alignItems='center' justifyContent='center' style={{ paddingBottom: "4px"}}>
							{this.props.windowWidth > 520 ?
							<>
									<Grid item  >
										<Button variant="outlined" color="primary"
											className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
											//className={`${classes.dateButton} ${classes.size}`}
											style={{ marginLeft: "0px", marginRight: "4px" }}
											onClick={() =>  this.setLang(1)}
										>	
											<ArrowForwardIosSharpIcon className={classes.arrow} />
										</Button>

										{/* <Button variant="outlined" color="primary"
									className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
									//className={`${classes.dateButton} ${classes.size}`}
									style={{ marginLeft: "4px", marginRight: "0px" }}
									onClick={() => this.plusDayFrom()}
								>
									<ArrowForwardIosSharpIcon className={classes.arrow} />
								</Button> */}
									</Grid>
								<Grid item  className={`${classes.gridBorder} ${classes.gridFlex}`} style={{ maxWidth: this.props.windowWidth > 700 ? "calc(25% + -3px)" : "150px" }}>

									<FlagIconsCalendar flags={['pl', 'en']} />

								</Grid> </> : null}
							<Grid item  className={`${classes.gridBorder} ${classes.gridFlex}`} style={{marginLeft: this.props.windowWidth > 500 ? "4px" : "0px", maxWidth: this.props.windowWidth > 700 ? "calc(25% + -3px)" : "150px"}}>
							<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "center", fontSize: "12px", whiteSpace: "break-spaces", textTransform: "lowercase", padding: "5px 0px" }}>
									<Trans>Check-in</Trans>{" "}

								</Typography>
							</Grid>
							<Grid item className={`${classes.gridBorder} ${classes.gridFlex}`} style={{marginLeft: "5px", minWidth: this.props.windowWidth > 500 ? "calc(50% + -74px)" : "calc(50%)" }} >
							<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "center", fontSize: "12px", whiteSpace: "break-spaces", padding: "5px 0px", fontWeight: "bold" }}>


										<span className={classes.primary} style={{padding: 0}}>{this.state.from}{" " + this.getDayOfWeek(this.state.from)}</span>

								</Typography>
							</Grid>
							<Grid item  >
							<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "left", fontSize: "12px" }}>

							<Button variant="outlined" color="primary"
										className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
										//className={`${classes.dateButton} ${classes.size}`}
										style={{ marginLeft: "4px", marginRight: "0px" }}
										onClick={() => this.minusDayFrom()}
										>
										<ArrowBackIosSharpIcon className={classes.arrow} />
									</Button>

								<Button variant="outlined" color="primary"
									className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
									//className={`${classes.dateButton} ${classes.size}`}
									style={{ marginLeft: "4px", marginRight: "0px" }}
									onClick={() => this.plusDayFrom()}
								>
									<ArrowForwardIosSharpIcon className={classes.arrow} />
								</Button>

								</Typography>
							</Grid>
						</Grid>



						<Grid container direction="row" alignItems='center' justifyContent='center'>
							{this.props.windowWidth > 520 ?
								<>
									<Grid item  >
										<Button variant="outlined" color="primary"
									className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
									//className={`${classes.dateButton} ${classes.size}`}
									style={{ marginLeft: "0px", marginRight: "4px", height: "30.5px" }}
									onClick={() => this.setLang(-1)}
								>
									<ArrowBackIosSharpIcon className={classes.arrow} />
								</Button>
									</Grid>
									<Grid item className={`${classes.gridBorder} ${classes.gridFlex}`} style={{ maxWidth: this.props.windowWidth > 700 ? "calc(25% + -3px)" : "150px" }}>
										<FlagIconsCalendar flags={['de', 'sk']} />
									</Grid></> : null}
							<Grid item className={`${classes.gridBorder} ${classes.gridFlex}`} style={{marginLeft: this.props.windowWidth > 500 ? "4px" : "0px", maxWidth: this.props.windowWidth > 700 ? "calc(25% + -3px)" : "150px"}}>
							<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "center", fontSize: "12px", whiteSpace: "break-spaces", textTransform: "lowercase", padding: "5px 0px" }}>
									<Trans>Check-out</Trans>{" "}

								</Typography>
							</Grid>
							<Grid item className={`${classes.gridBorder} ${classes.gridFlex}`} style={{marginLeft: "5px", minWidth: this.props.windowWidth > 500 ? "calc(50% + -74px)" : "calc(50%)" }} >
							<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "center", fontSize: "12px", whiteSpace: "break-spaces", padding: "5px 0px", minHeight: "19px", fontWeight: "bold" }}>

									{this.state.to ? <>
										<span className={classes.primary} style={{padding: 0}}>{this.state.to}{" " + this.getDayOfWeek(this.state.to) + ", "}
											{diff} {diffText}</span>
									</> : null}
								</Typography>
							</Grid>
							<Grid item  >
							<Typography variant="h6" component="h2" color="primary" style={{ textAlign: "left", fontSize: "12px" }}>

							<Button variant="outlined" color="primary"
										className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
										//className={`${classes.dateButton} ${classes.size}`}
										style={{ marginLeft: "4px", marginRight: "0px" }}
										onClick={() => this.minusDayTo()}
										>
										<ArrowBackIosSharpIcon className={classes.arrow} />
									</Button>

								<Button variant="outlined" color="primary"
									className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
									//className={`${classes.dateButton} ${classes.size}`}
									style={{ marginLeft: "4px", marginRight: "0px" }}
									onClick={() => this.plusDayTo()}
								>
									<ArrowForwardIosSharpIcon className={classes.arrow} />
								</Button>

								</Typography>
							</Grid>
						</Grid>






						{/* <hr /> */}
					</DialogTitle>
					 <DialogContent style={{ overflowY: "initial", padding: this.props.windowWidth < 500 ? "4px 4px 10px" : "4px 12px 10px",  }}>  {/*minWidth: this.props.windowWidth < 600 ? "645px" : "680px" */}
						<MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={setLocale("pl")}>
							<div id='rangePicker'>
								<RangePicker {...rangePickerProps} />
							</div>
						</MuiPickersUtilsProvider>




					</DialogContent >
					<DialogActions style={{ position: "sticky", left: "0px", padding: "20px", display: "inline" }} >
						<Button onClick={() => this.setToday()} variant="outlined" size="small" color="primary"
							style={{ textTransform: "none", fontSize: "0.8rem" }}
						>
							<Trans>Today</Trans>
						</Button>
						<Button onClick={() => this.setTomorrow()} variant="outlined" size="small" color="primary"
							style={{ textTransform: "none", fontSize: "0.8rem" }}
						>
							<Trans>Tomorow</Trans>
						</Button>
						{this.props.windowWidth > 500 ? 
						<Button onClick={() => this.setWeekend()} variant="outlined" size="small" color="primary"
							style={{ textTransform: "none", fontSize: "0.8rem" }}
						>
							<Trans>Weekend</Trans>
						</Button> : null}
						<Button onClick={() => this.accept()} variant="contained" size="small" color="primary"
							style={{ textTransform: "none", fontSize: "0.8rem", color: "white", float: "right" }}
						>
							<b><Trans>OK</Trans></b>
						</Button>
						<Button onClick={() => this.props.close()} variant="outlined" size="small" color="primary"
							style={{ textTransform: "none", fontSize: "0.8rem", float: "right" }}
						>
							<b><Trans>Back</Trans></b>
						</Button>
						
					</DialogActions>
				</Dialog>
			</MuiThemeProvider>
		);
	}
}

const styles = (theme: Theme) => ({
	primary: {
		color: themeEdit.palette.primary.main,
		padding: "0px 5px"
	},
	secondary: {
		color: themeEdit.palette.secondary.main,
		//color: "rgb(230, 81, 0)",//themeEdit.palette.secondary.main,
		padding: "0px 5px"
	},
	tableCell: {
		cursor: "pointer"
	},
	cell: {
		padding: "0px",
		borderBottom: "0",
		width: "63%",
		fontSize: "1rem",
		color: themeEdit.palette.primary.main,
	},
	listItem: {
		//textAlign: "center" as "center",
		paddingTop: "0",
		paddingBottom: "0"
	},
	headline: {
		lineHeight: "20px",
		//textAlign: "center" as "center"
	},
	title: {
		padding: "28px 24px 0px 24px"
	},
	paper: {
		//maxWidth: "720px",
		maxWidth: "680px",
		//maxHeight: "calc(100% - 44px)"
	},

	input: {
		fontSize: "11px",
		fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
		lineHeight: "20px",
		fontWeight: "bold" as "bold",
		textTransform: "lowercase" as "lowercase",
		height: "14px",
		padding: "8px 2px",
		borderRadius: "0px"
	  },
	  margin: {
		//marginTop: "4px",
		//marginBottom: "4px",
		//marginTop: "0px",
		//marginBottom: "4px",
	  },
	  horitzontalMargin: {
		marginLeft: '5px',
		marginRight: '5px'
	  },
	  dateBorder: {
		borderStyle: "solid",
		borderWidth: "1px",
		//borderColor: theme.palette.primary.main,
		///borderColor: "lightgrey",
		borderColor: "lavender",

		borderRadius: "0px",
		//borderRadius: "4px",
		"&:hover": {
		  //borderRadius: "4px",
		  borderRadius: "0px",
		  borderColor: theme.palette.primary.dark,
		  backgroundColor: 'rgba(69, 139, 0, 0.04)',
		},
	  },
	  nav: {
		padding: "0",
		width: "32px",
		height: "31px",
		minWidth: "0",
		marginTop: "0",
		color: "lavender",
		//color: "rgb(230, 81, 0)",
		//color: "rgba(69, 139, 0, 0.5)",
		"&:hover": {
		  color: "rgba(69, 139, 0, 0.5)",
		},
	  },
	  gridBorder: {
		border: "1px solid lavender"
	  },
	  gridFlex: {
		flex: "1"
	  },
	  arrow: {
		paddingBottom: "1px",
		width: "10px !important"
	  }

});

const mapStateToProps = (state: AppState) => ({
	page: state.pageState
});


export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(MyApp)));
